import XHeader from 'vux/src/components/x-header/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

export default {
name: 'personage',
components: {
XHeader,


XButton,
PopupRadio,
Actionsheet
},
data () {
return {
myInfo: {},
}
},
methods: {
getMyInfo () {
this.$request.post('/user/getMyOrderInfo',{

}).then(data => {
if(data.code == 0){
this.myInfo = data.obj
if(!this.myInfo.imagePath){
this.myInfo.imagePath = require('../../assets/images/personBg.png')
}
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
address () {
this.$router.push({
path: '/myAddress'
})
},
myOrder (orderStatus) {
this.$router.push({
path: '/myOrder',
query: {
orderStatus
}
})
this.$route.meta.keepAlive = false
},
shoppingCart () {
this.$router.push({
path: '/shoppingCart',
query: {
type: 'productCenter'
}
})
},
myIssue () {
this.$router.push({
path: '/myIssue'
})
},
myCollect () {
this.$router.push({
path: '/myCollect'
})
},
myDesign () {
this.$router.push({
path: '/myDesign'
})
},
generalize () {
this.$router.push({
path: '/generalize'
})
},
myIntegral () {
this.$router.push({
path: '/integral'
})
},
myVoucher () {
this.$router.push({
path: '/myVoucher'
})
},
getVoucher () {
this.$router.push({
path: '/getVoucher'
})
},
invoiceInfo () {
this.$router.push({
path: '/invoiceInfo'
})
},
sqdzfp () {
this.$router.push({
path: '/requestInvoice'
})
},
commission () {
this.$router.push({
path: '/commission'
})
},
myStore () {
this.$router.push({
path: '/myStore'
})
},
},
created () {
this.getMyInfo()
},
mounted() {

}
}



// WEBPACK FOOTER //
// ./src/views/personage/script.js